import React from 'react';
import RowExpanded from '../assets/images/rowexpansionexpandedicon.svg';

export default () => {
  return <img src={RowExpanded} alt="" />;
};
